var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"warning-icon",style:({ left: this.left ? this.left + 'px' : 0, top: _vm.top + 'px' }),attrs:{"alt":"proposition 65 consumption warning symbol","src":require("@/assets/warning.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }